import React from 'react';
import PropTypes from 'prop-types';
import s from '../../../../screens/staking/card-table/items/item.module.scss';
import ColumnEstimatedDailyRewardsTitle from './title';
import theme from '../../../../theme';
import { formatToken } from '../../../../helpers/token-helper';

const ColumnEstimatedDailyRewards = ({ estimatedDailyReward, titleRewardToken }) => {
  return (
    <>
      <ColumnEstimatedDailyRewardsTitle isMobile />
      <div className={s.col}>
        <span
          className={s.topLine}
          style={{ color: theme.palette.mantra.pink, display: 'inline-block' }}
        >
          {estimatedDailyReward > 0 ? '~' : ''}
          {formatToken(estimatedDailyReward)} {titleRewardToken}
        </span>
      </div>
    </>
  );
};

ColumnEstimatedDailyRewards.propTypes = {
  titleRewardToken: PropTypes.string.isRequired,
  estimatedDailyReward: PropTypes.string.isRequired,
};

export default ColumnEstimatedDailyRewards;
